export const ImgWave = () => {
  return (
    <svg viewBox="0 0 1366 98" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M71.5 75.5C38.5 65.5 0 48.6381 0 48.6381V-48H1366V80.2714C1332.82 63.2381 1250.43 46.1919 1228.5 43C1189.6 37.3381 1125 29.9046 1104 27.781C1083 25.6573 1005.47 22.219 958.414 22.219C905.056 22.219 858.845 22.7777 818.083 25C772.587 27.4803 746.475 30.0415 702.371 34.3675L698.641 34.7333C657.075 38.8089 633.909 41.9089 592.945 47.9428C533.607 56.6831 443.168 73.6666 443.168 73.6666C443.168 73.6666 376.5 88.2667 330.836 92.4381C330.836 92.4381 270.5 98 238 98C202 98 137.5 89.3095 137.5 89.3095C113.5 85.1381 100.519 84.2935 71.5 75.5Z"
        fill="#15477A"
        fillOpacity="0.4"
      />
    </svg>
  );
};
